/**
 * FilterChipRow — a horizontally scrolling row of single-select filter chips
 * with a leading "all" chip (BON-142). Used for the picker's tree-type filter.
 * Renders nothing when there is nothing to choose between.
 */
import type { FilterOption } from './WorkshopPickerHelpers';

export interface FilterChipRowProps {
  ariaLabel: string;
  allLabel: string;
  options: FilterOption[];
  activeId: string | null;
  onChange: (id: string | null) => void;
}

export function FilterChipRow({
  ariaLabel,
  allLabel,
  options,
  activeId,
  onChange,
}: FilterChipRowProps) {
  if (options.length === 0) return null;
  const chips = [{ id: null as string | null, label: allLabel }, ...options];
  return (
    <div role="group" aria-label={ariaLabel} className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-1">
      {chips.map((o) => {
        const active = activeId === o.id;
        return (
          <button
            key={o.id ?? 'all'}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(o.id)}
            className={`whitespace-nowrap rounded-full border px-3 py-1.5 text-xs font-medium transition ${
              active
                ? 'border-moss-600 bg-moss-600 text-white'
                : 'border-stone-200 bg-white text-stone-600 hover:border-stone-300 dark:border-stone-700 dark:bg-[#1a1f1c] dark:text-stone-300'
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
